module.exports = __webpack_public_path__ + "static/yoga-stance-82162613f727ad040b07414ab313c333.jpg";